import onetime from "@-/com.npmjs.onetime";
import type { Event } from "@sentry/core";

export type SentryAnalyticsIdentity = {
  distinctId: string;
  /** Read per event: PostHog rotates session ids, and the replay to open is the current one. */
  getSessionId: () => string;
};

const getLinkState = onetime((): { identity: SentryAnalyticsIdentity | null } => ({
  identity: null,
}));

export function setSentryAnalyticsLink(identity: SentryAnalyticsIdentity | null): void {
  getLinkState().identity = identity;
}

/**
 * Tags every event with the analytics identity and session, so a Sentry issue leads straight to
 * the PostHog person and the session replay that recorded it.
 */
export function createSentryAnalyticsLinkProcessor(): (event: Event) => Event {
  return (event) => {
    const { identity } = getLinkState();
    if (identity === null) {
      return event;
    }
    let sessionId: string | undefined;
    try {
      sessionId = identity.getSessionId() || undefined;
    } catch {
      // The analytics client is optional context; never let it break error reporting.
    }
    event.tags = {
      ...event.tags,
      posthog_distinct_id: identity.distinctId,
      ...(sessionId === undefined ? {} : { posthog_session_id: sessionId }),
    };
    return event;
  };
}
